import { defineModule } from '@/js/utils/helpers';

/**
 * The play disc swaps the poster for the embed that PHP parked in a <template>
 * beside it. Nothing is loaded until the visitor asks for it, so an unplayed
 * video costs no requests.
 */

let players: HTMLElement[] = [];

const onClick = (event: Event) => {
  const player = (event.currentTarget as HTMLElement) ?? null;
  const embed =
    player?.querySelector<HTMLTemplateElement>('[data-video-embed]');
  if (!embed) return;

  event.preventDefault();

  const frame = embed.content.cloneNode(true);
  player.replaceChildren(frame);
  player.classList.add('is-playing');
  player.removeEventListener('click', onClick);

  // Autoplay the freshly inserted embed — the click is the consent.
  const iframe = player.querySelector('iframe');
  if (iframe) {
    const separator = iframe.src.includes('?') ? '&' : '?';
    iframe.src = `${iframe.src}${separator}autoplay=1`;
  }
};

export default defineModule(
  () => {
    players = Array.from(
      document.querySelectorAll<HTMLElement>('[data-video]'),
    );
    players.forEach((player) => player.addEventListener('click', onClick));
  },
  () => {
    players.forEach((player) => player.removeEventListener('click', onClick));
    players = [];
  },
);
